import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './assets/themes/theme';
import DrawerAppBar from './components/DrawerAppBar';
import { motion } from "framer-motion";
import { Container, IconButton, useMediaQuery } from '@mui/material';
import { ArrowCircleUp } from '@mui/icons-material';
import ContactForm from './contact-us/ContactForm';

const Home = React.lazy(() => import('./home/Home'));
const AboutUs = React.lazy(() => import('./about-us/AboutUs'));
const ContactUs = React.lazy(() => import('./contact-us/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
const App: React.FC = () => {

  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));

  const getY = () => {
    if (isXs || isSm) {
      return 0;
    }
    if (isMd) {
      return -24;
    }
    return -24;
  }

  const navContainer = {
    visible: { opacity: 1, y: getY() },
    hidden: { opacity: 0, y: "-4rem" },
  };

  const [isVisible, setIsVisible] = React.useState(false);

  const scrollToTop = (behavior: ScrollBehavior = "auto") => {
    window.scrollTo({
      top: 0,
      behavior: behavior
    });
  };

  const location = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [location])

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <div className="root">
        <CssBaseline />
        <main>
          <Container sx={{
            maxWidth: "1440px !important",
            padding: {
              xs: "0px !important",
              sm: "12px !important",
              md: "0px !important"
            }
          }}>
            <motion.nav
              style={{ position: 'relative', zIndex: 1100 }}
              variants={navContainer}
              animate={isVisible ? "hidden" : "visible"}
              transition={{
                ease: [0.1, 0.25, 0.3, 1],
                duration: 0.6,
                staggerChildren: 0.05,
              }}
            >
              <DrawerAppBar />
            </motion.nav>
            <React.Suspense fallback={<>...</>}>
              <Routes>
                <Route path='/' element={
                  <Home />
                } />
                <Route path='/about-us' element={<AboutUs />} />
                <Route path='/contact-us' element={<ContactUs />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              {!location.pathname.startsWith("/about-us") &&
                <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
                  <ContactForm />
                </motion.div>}
              <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}>
                <Footer />
              </motion.div>
            </React.Suspense>
            {isVisible && <IconButton
              sx={{ position: "fixed", bottom: 10, right: 10, zIndex: 999 }}
              onClick={() => scrollToTop("smooth")}>
              <ArrowCircleUp fontSize='large' sx={{ color: "#F6F6F7", backgroundColor: "#BA1B1D", borderRadius: "50%" }} />
            </IconButton>}
          </Container>
        </main>
      </div>
    </ThemeProvider >
  );

}

export default App;